const Tdata = [

    {
        id: 1,
        name: "Git",
        imgsrc: "./Images/git.svg"
    },

    {
        id: 2,
        name: "GitHub",
        imgsrc: "./Images/github.svg"
    },

    {
        id: 3,
        name: "AWS EC2",
        imgsrc: "./Images/aws.svg"
    },

    {
        id: 4,
        name: "WordPress",
        imgsrc: "./Images/wordpress.svg"
    },
    {
        id: 5,
        name: "NPM",
        imgsrc: "./Images/npm.svg"
    },
    {
        id: 6,
        name: "Babel",
        imgsrc: "./Images/babel.svg"
    },
    {
        id: 7,
        name: "VS Code",
        imgsrc: "./Images/vscode.svg"
    },
    {
        id: 8,
        name: "Figma",
        imgsrc: "./Images/figma-icon.svg"
    },
        {
        id: 9,
        name: "Adobe Xd",
        imgsrc: "./Images/adobe-xd.svg"
    },
        {
        id: 10,
        name: "WooCommerce",
        imgsrc: "./Images/woocom.svg"
    }

]

export default Tdata;